// import GT from '../../Images/GT.jpg'
import React from "react";

const S = {
  wrapper: {
    marginTop: '10px', marginLeft: '0px', border: '3px', padding: '40px',
    borderStyle: 'solid', borderColor: 'grey', fontFamily: "'Georgia', serif",
    color: '#1a1a2e', lineHeight: '1.7',
  },
  h1: {
    fontSize: '2rem', fontWeight: '700', borderBottom: '3px solid #2E75B6',
    paddingBottom: '8px', marginBottom: '24px', color: '#1F3864',
  },
  h2: {
    fontSize: '1.3rem', fontWeight: '700', color: '#2E75B6', marginTop: '36px',
    marginBottom: '12px', borderLeft: '4px solid #2E75B6', paddingLeft: '10px',
  },
  p: { marginBottom: '12px', fontSize: '0.97rem' },
  infoBox: {
    background: '#EBF3FB', border: '2px solid #2E75B6', borderRadius: '6px',
    padding: '16px 20px', margin: '16px 0',
  },
  infoBoxTitle: {
    fontWeight: '700', fontFamily: "'Courier New', monospace", fontSize: '0.88rem',
    color: '#1F3864', marginBottom: '8px',
  },
  infoBoxItem: {
    fontSize: '0.9rem', margin: '4px 0', paddingLeft: '12px', borderLeft: '2px solid #2E75B6',
  },
  table: { width: '100%', borderCollapse: 'collapse', marginBottom: '20px', fontSize: '0.92rem' },
  th: { background: '#2E75B6', color: '#fff', padding: '10px 14px', textAlign: 'left', fontWeight: '700', fontSize: '0.9rem' },
  tdE: { padding: '10px 14px', borderBottom: '1px solid #ccd9ea', verticalAlign: 'top', background: '#f5f9ff' },
  tdO: { padding: '10px 14px', borderBottom: '1px solid #ccd9ea', verticalAlign: 'top', background: '#fff' },
  tdL: { fontWeight: '600', color: '#1F3864', whiteSpace: 'nowrap', width: '220px' },
  code: { fontFamily: "'Courier New', monospace", fontSize: '0.88rem', whiteSpace: 'pre-wrap' },
  dWrap: {
    margin: '24px 0', background: '#f8fbff', border: '1px solid #ccd9ea',
    borderRadius: '8px', padding: '20px',
  },
  dTitle: {
    fontWeight: '700', fontSize: '0.95rem', color: '#1F3864',
    marginBottom: '12px', textAlign: 'center', letterSpacing: '0.02em',
  },
  dCaption: { fontSize: '0.84rem', color: '#555', textAlign: 'center', marginTop: '10px', fontStyle: 'italic' },
  twoCol: { display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' },
  colCard: {
    flex: '1', minWidth: '220px', background: '#fff',
    border: '1px solid #ccd9ea', borderRadius: '6px', padding: '14px', textAlign: 'center',
  },
  colCardTitle: { fontWeight: '700', fontSize: '0.9rem', marginBottom: '6px' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width: '220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i % 2 === 0 ? S.tdE : S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i % 2 === 0 ? S.tdE : S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 1 — Growth vs Decay curves
// ─────────────────────────────────────────────────────────────────
function DiagramGrowthDecay() {
  const cardW = 240, cardH = 180;
  const pad = { l: 40, r: 16, t: 20, b: 36 };
  const iW = cardW - pad.l - pad.r;
  const iH = cardH - pad.t - pad.b;
  const xMax = 2.5, yMax = 7, yMin = 0;

  const toX = t => pad.l + (t / xMax) * iW;
  const toY = y => pad.t + iH - ((Math.min(y, yMax) - yMin) / (yMax - yMin)) * iH;

  const growthPts = [], decayPts = [];
  for (let x = 0; x <= xMax; x += 0.04) {
    growthPts.push(`${toX(x)},${toY(Math.exp(x))}`);
    decayPts.push(`${toX(x)},${toY(Math.exp(-x))}`);
  }

  const keyPoints = [
    { x: 0, y: 1, label: '(0,1)', color: '#1F3864' },
    { x: 1, y: Math.E, label: '(1, e)', color: '#2E75B6' },
    { x: 2, y: Math.exp(2), label: '(2, e²)', color: '#2E75B6' },
  ];
  const keyDecay = [
    { x: 0, y: 1, label: '(0,1)', color: '#1F3864' },
    { x: 1, y: 1 / Math.E, label: '(1, 1/e)', color: '#c0392b' },
    { x: 2, y: Math.exp(-2), label: '(2, 1/e²)', color: '#c0392b' },
  ];

  const renderCard = (pts, color, title, subtitle, kpts) => (
    <div style={{ ...S.colCard, minWidth: '220px' }}>
      <div style={{ ...S.colCardTitle, color }}>{title}</div>
      <div style={{ fontSize: '0.78rem', color: '#666', marginBottom: '6px', fontFamily: "'Courier New', monospace" }}>{subtitle}</div>
      <svg width={cardW} height={cardH} viewBox={`0 0 ${cardW} ${cardH}`} style={{ maxWidth: '100%' }}>
        {/* Grid */}
        {[0,1,2].map(x => <line key={x} x1={toX(x)} y1={pad.t} x2={toX(x)} y2={pad.t+iH} stroke="#eee" strokeWidth="1"/>)}
        {[0,1,2,4,7].map(y => <line key={y} x1={pad.l} y1={toY(y)} x2={pad.l+iW} y2={toY(y)} stroke="#eee" strokeWidth="1"/>)}
        {/* Axes */}
        <line x1={pad.l} y1={pad.t} x2={pad.l} y2={pad.t+iH} stroke="#aaa" strokeWidth="1.3"/>
        <line x1={pad.l} y1={pad.t+iH} x2={pad.l+iW} y2={pad.t+iH} stroke="#aaa" strokeWidth="1.3"/>
        {/* Tick labels */}
        {[0,1,2].map(x => <text key={x} x={toX(x)} y={pad.t+iH+14} textAnchor="middle" fontSize="9" fill="#aaa">{x}</text>)}
        {[1,2,4,7].map(y => <text key={y} x={pad.l-4} y={toY(y)+3} textAnchor="end" fontSize="9" fill="#aaa">{y}</text>)}
        {/* Curve */}
        <path d={'M ' + pts.join(' L ')} fill="none" stroke={color} strokeWidth="2.3" strokeLinejoin="round"/>
        {/* Key points */}
        {kpts.map((p, i) => {
          if (p.y > yMax) return null;
          return (
            <g key={i}>
              <circle cx={toX(p.x)} cy={toY(p.y)} r={3.5} fill={p.color} stroke="#fff" strokeWidth="1"/>
              <text x={toX(p.x) + 5} y={toY(p.y) - 5} fontSize="9" fill={p.color} fontWeight="700">{p.label}</text>
            </g>
          );
        })}
        {/* Axis labels */}
        <text x={pad.l+iW} y={pad.t+iH+14} fontSize="9" fill="#aaa">x</text>
        <text x={pad.l-4} y={pad.t} fontSize="9" fill="#aaa" textAnchor="middle">y</text>
      </svg>
    </div>
  );

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Exponential Growth vs. Decay — Key Points and Behavior</div>
      <div style={S.twoCol}>
        {renderCard(growthPts, '#2E75B6', 'Growth',  'y = e^x', keyPoints)}
        {renderCard(decayPts,  '#c0392b', 'Decay',   'y = e^(-x)', keyDecay)}
      </div>
      <div style={S.dCaption}>
        Both curves pass through (0, 1). Growth increases without bound. Decay approaches 0 but never reaches it — this is called an asymptote.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 2 — Natural Log as Inverse of e^x
// ─────────────────────────────────────────────────────────────────
function DiagramLogInverse() {
  const W = 480, H = 280;
  const ox = 100, oy = 220, sc = 55;
  const toSVG = (x, y) => [ox + x * sc, oy - y * sc];

  const expPts = [], lnPts = [], mirrorPts = [];
  for (let t = -1.2; t <= 3.0; t += 0.04) {
    const [sx, sy] = toSVG(t, Math.exp(t));
    if (sy > 10 && sy < H - 10 && sx > 10 && sx < W - 10) expPts.push(`${sx},${sy}`);
  }
  for (let t = 0.05; t <= 3.5; t += 0.04) {
    const [sx, sy] = toSVG(t, Math.log(t));
    if (sy > 10 && sy < H - 10 && sx > 10 && sx < W - 10) lnPts.push(`${sx},${sy}`);
  }
  // Mirror line y=x
  for (let t = -0.5; t <= 3.2; t += 0.5) {
    const [sx, sy] = toSVG(t, t);
    mirrorPts.push(`${sx},${sy}`);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Natural Log as the Inverse — ln(x) mirrors e^x across y = x</div>
      <div style={{ textAlign: 'center' }}>
        <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} style={{ maxWidth: '100%' }}>
          {/* Grid */}
          {[-1,0,1,2,3].map(v => {
            const [sx] = toSVG(v, 0), [,sy] = toSVG(0, v);
            return <g key={v}>
              <line x1={sx} y1={10} x2={sx} y2={H-10} stroke="#eee" strokeWidth="1"/>
              <line x1={10} y1={sy} x2={W-10} y2={sy} stroke="#eee" strokeWidth="1"/>
              <text x={sx} y={oy+14} textAnchor="middle" fontSize="9" fill="#bbb">{v}</text>
              <text x={ox-5} y={sy+3} textAnchor="end" fontSize="9" fill="#bbb">{v}</text>
            </g>;
          })}
          {/* Axes */}
          <line x1={10} y1={oy} x2={W-10} y2={oy} stroke="#1F3864" strokeWidth="1.5"/>
          <line x1={ox} y1={10} x2={ox} y2={H-10} stroke="#1F3864" strokeWidth="1.5"/>
          <text x={W-8} y={oy-4} fontSize="11" fill="#1F3864" fontWeight="700">x</text>
          <text x={ox+4} y={12} fontSize="11" fill="#1F3864" fontWeight="700">y</text>

          {/* Mirror line y=x */}
          <path d={'M ' + mirrorPts.join(' L ')} fill="none" stroke="#ccc" strokeWidth="1.3" strokeDasharray="5,4"/>
          <text x={toSVG(2.8,2.8)[0]+4} y={toSVG(2.8,2.8)[1]-6} fontSize="10" fill="#aaa">y = x</text>

          {/* e^x curve */}
          <path d={'M ' + expPts.join(' L ')} fill="none" stroke="#2E75B6" strokeWidth="2.3" strokeLinejoin="round"/>
          {/* ln(x) curve */}
          <path d={'M ' + lnPts.join(' L ')} fill="none" stroke="#c0392b" strokeWidth="2.3" strokeLinejoin="round"/>

          {/* Labels */}
          {(() => {
            const [lx,ly] = toSVG(1.1, Math.exp(1.1));
            const [rx,ry] = toSVG(Math.exp(1.1), 1.1);
            return <>
              <text x={lx+5} y={ly-6} fontSize="12" fill="#2E75B6" fontWeight="700">y = e^x</text>
              <text x={rx+5} y={ry+4} fontSize="12" fill="#c0392b" fontWeight="700">y = ln(x)</text>
            </>;
          })()}

          {/* Key reflection points */}
          {[[0,1,'(0,1)','#2E75B6'],[1,Math.E,'(1,e)','#2E75B6']].map(([x,y,lbl,col],i) => {
            const [sx,sy] = toSVG(x,y);
            return <g key={i}>
              <circle cx={sx} cy={sy} r={4} fill={col} stroke="#fff" strokeWidth="1.2"/>
              <text x={sx-6} y={sy-8} fontSize="9" fill={col} fontWeight="700">{lbl}</text>
            </g>;
          })}
          {[[1,0,'(1,0)','#c0392b'],[Math.E,1,'(e,1)','#c0392b']].map(([x,y,lbl,col],i) => {
            const [sx,sy] = toSVG(x,y);
            return <g key={i}>
              <circle cx={sx} cy={sy} r={4} fill={col} stroke="#fff" strokeWidth="1.2"/>
              <text x={sx+5} y={sy-6} fontSize="9" fill={col} fontWeight="700">{lbl}</text>
            </g>;
          })}

          {/* Reflection arrows */}
          {(() => {
            const [ax,ay] = toSVG(0.3, Math.exp(0.3)), [bx,by] = toSVG(Math.exp(0.3), 0.3);
            return <>
              <line x1={ax} y1={ay} x2={bx} y2={by} stroke="#e07b00" strokeWidth="1.2" strokeDasharray="3,3"/>
              <text x={(ax+bx)/2+5} y={(ay+by)/2-6} fontSize="9" fill="#e07b00">reflection</text>
            </>;
          })()}
        </svg>
      </div>
      <div style={S.dCaption}>
        ln(x) is the inverse of e^x. Every point (a, b) on e^x has a mirror point (b, a) on ln(x). This means e^(ln x) = x and ln(e^x) = x always.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 3 — Half-life and Doubling Time
// ─────────────────────────────────────────────────────────────────
function DiagramHalfLife() {
  const W = 500, H = 240;
  const pad = { l: 55, r: 20, t: 20, b: 40 };
  const iW = W - pad.l - pad.r, iH = H - pad.t - pad.b;
  const tMax = 5, y0val = 1.0;
  const k = Math.log(2); // so T_half = 1 unit

  const toX = t => pad.l + (t / tMax) * iW;
  const toY = y => pad.t + iH - (y / y0val) * iH;

  const pts = [];
  for (let t = 0; t <= tMax; t += 0.04) {
    pts.push(`${toX(t)},${toY(y0val * Math.exp(-k * t))}`);
  }

  const halfLevels = [1, 0.5, 0.25, 0.125, 0.0625];
  const halfTimes  = [0, 1,   2,    3,     4];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Half-Life — Each Interval Cuts the Value in Half</div>
      <div style={{ textAlign: 'center' }}>
        <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} style={{ maxWidth: '100%' }}>
          {/* Horizontal dashed lines at each half level */}
          {halfLevels.map((lv, i) => (
            <line key={i} x1={pad.l} y1={toY(lv)} x2={pad.l + iW} y2={toY(lv)}
              stroke="#e07b00" strokeWidth="1" strokeDasharray="4,4" opacity="0.6"/>
          ))}
          {/* Vertical dashed lines at each half-time */}
          {halfTimes.map((t, i) => (
            <line key={i} x1={toX(t)} y1={pad.t} x2={toX(t)} y2={pad.t + iH}
              stroke="#e07b00" strokeWidth="1" strokeDasharray="4,4" opacity="0.5"/>
          ))}
          {/* Axes */}
          <line x1={pad.l} y1={pad.t} x2={pad.l} y2={pad.t+iH} stroke="#1F3864" strokeWidth="1.5"/>
          <line x1={pad.l} y1={pad.t+iH} x2={pad.l+iW} y2={pad.t+iH} stroke="#1F3864" strokeWidth="1.5"/>
          <text x={pad.l+iW+4} y={pad.t+iH+4} fontSize="11" fill="#1F3864">t</text>
          <text x={pad.l-4} y={pad.t+4} textAnchor="end" fontSize="11" fill="#1F3864">N(t)</text>

          {/* Curve */}
          <path d={'M ' + pts.join(' L ')} fill="none" stroke="#c0392b" strokeWidth="2.5" strokeLinejoin="round"/>

          {/* Key point markers */}
          {halfLevels.map((lv, i) => {
            const t = halfTimes[i];
            const labels = ['N₀', 'N₀/2', 'N₀/4', 'N₀/8', 'N₀/16'];
            return (
              <g key={i}>
                <circle cx={toX(t)} cy={toY(lv)} r={4.5} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
                <text x={pad.l - 6} y={toY(lv) + 4} textAnchor="end" fontSize="10" fill="#c0392b" fontWeight="700">{labels[i]}</text>
                <text x={toX(t)} y={pad.t + iH + 14} textAnchor="middle" fontSize="10" fill="#e07b00" fontWeight="700">T={t}</text>
              </g>
            );
          })}

          {/* T_half bracket */}
          {[0,1,2,3].map(i => {
            const x1 = toX(halfTimes[i]), x2 = toX(halfTimes[i+1]);
            const y = pad.t + iH + 26;
            return (
              <g key={i}>
                <line x1={x1} y1={y} x2={x2} y2={y} stroke="#e07b00" strokeWidth="1.5"/>
                <line x1={x1} y1={y-4} x2={x1} y2={y+4} stroke="#e07b00" strokeWidth="1.5"/>
                <line x1={x2} y1={y-4} x2={x2} y2={y+4} stroke="#e07b00" strokeWidth="1.5"/>
                <text x={(x1+x2)/2} y={y+12} textAnchor="middle" fontSize="9" fill="#e07b00">T½</text>
              </g>
            );
          })}

          {/* Formula box */}
          <rect x={toX(2.6)} y={pad.t+10} width={145} height={52} rx={4} fill="#fff" stroke="#ccd9ea"/>
          <text x={toX(2.6)+72} y={pad.t+26} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">N(t) = N₀ · e^(-kt)</text>
          <text x={toX(2.6)+72} y={pad.t+42} textAnchor="middle" fontSize="10" fill="#c0392b">T½ = ln(2) / k</text>
          <text x={toX(2.6)+72} y={pad.t+56} textAnchor="middle" fontSize="10" fill="#2E75B6">k = ln(2) / T½</text>
        </svg>
      </div>
      <div style={S.dCaption}>
        Each T½ interval the quantity halves. The decay constant k and half-life are directly related: T½ = ln(2)/k ≈ 0.693/k. Same math applies to RC circuit discharge, radioactive decay, and material fatigue.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 4 — Log Rules Visualized on a Number Line
// ─────────────────────────────────────────────────────────────────
function DiagramLogRules() {
  const W = 500, H = 200;
  const ox = 50, lineY = 80, sc = 90;

  // Show ln(2) + ln(3) = ln(6)
  const ln2 = Math.log(2), ln3 = Math.log(3), ln6 = Math.log(6);
  const toX = v => ox + v * sc;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Log Rules — ln(a) + ln(b) = ln(ab)  Visualized</div>
      <div style={{ textAlign: 'center' }}>
        <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} style={{ maxWidth: '100%' }}>

          {/* Number line */}
          <line x1={ox} y1={lineY} x2={ox + 2.0 * sc} y2={lineY} stroke="#1F3864" strokeWidth="2"/>
          {/* Tick at 0 */}
          <line x1={ox} y1={lineY-6} x2={ox} y2={lineY+6} stroke="#1F3864" strokeWidth="1.5"/>
          <text x={ox} y={lineY+18} textAnchor="middle" fontSize="11" fill="#1F3864">0</text>

          {/* ln(2) span */}
          <line x1={toX(0)} y1={lineY} x2={toX(ln2)} y2={lineY} stroke="#2E75B6" strokeWidth="5" strokeLinecap="round" opacity="0.7"/>
          <line x1={toX(ln2)} y1={lineY-8} x2={toX(ln2)} y2={lineY+8} stroke="#2E75B6" strokeWidth="2"/>
          <text x={toX(ln2)} y={lineY+18} textAnchor="middle" fontSize="10" fill="#2E75B6" fontWeight="700">ln 2 ≈ {ln2.toFixed(3)}</text>
          <text x={(toX(0)+toX(ln2))/2} y={lineY-14} textAnchor="middle" fontSize="11" fill="#2E75B6" fontWeight="700">ln(2)</text>

          {/* ln(3) span — stacked above */}
          <line x1={toX(ln2)} y1={lineY-22} x2={toX(ln2+ln3)} y2={lineY-22} stroke="#c0392b" strokeWidth="5" strokeLinecap="round" opacity="0.7"/>
          <line x1={toX(ln2)} y1={lineY-28} x2={toX(ln2)} y2={lineY-16} stroke="#c0392b" strokeWidth="2"/>
          <line x1={toX(ln2+ln3)} y1={lineY-28} x2={toX(ln2+ln3)} y2={lineY-16} stroke="#c0392b" strokeWidth="2"/>
          <text x={(toX(ln2)+toX(ln2+ln3))/2} y={lineY-32} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">ln(3)</text>

          {/* ln(6) total span */}
          <line x1={toX(0)} y1={lineY+38} x2={toX(ln6)} y2={lineY+38} stroke="#27ae60" strokeWidth="5" strokeLinecap="round" opacity="0.7"/>
          <line x1={toX(0)} y1={lineY+32} x2={toX(0)} y2={lineY+44} stroke="#27ae60" strokeWidth="2"/>
          <line x1={toX(ln6)} y1={lineY+32} x2={toX(ln6)} y2={lineY+44} stroke="#27ae60" strokeWidth="2"/>
          <text x={toX(ln6)} y={lineY+56} textAnchor="middle" fontSize="10" fill="#27ae60" fontWeight="700">ln 6 ≈ {ln6.toFixed(3)}</text>
          <text x={(toX(0)+toX(ln6))/2} y={lineY+56} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">ln(2) + ln(3) = ln(6)</text>

          {/* Equals sign connector */}
          <line x1={toX(ln6)} y1={lineY-4} x2={toX(ln6)} y2={lineY+34} stroke="#27ae60" strokeWidth="1.5" strokeDasharray="3,3"/>

          {/* Rule box */}
          <rect x={300} y={20} width={185} height={130} rx={5} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.3"/>
          <text x={392} y={40} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">Log Rules</text>
          {[
            ['ln(ab)', '= ln(a) + ln(b)', '#2E75B6'],
            ['ln(a/b)', '= ln(a) - ln(b)', '#c0392b'],
            ['ln(a^n)', '= n · ln(a)', '#27ae60'],
            ['ln(e^x)', '= x', '#e07b00'],
            ['e^(ln x)', '= x', '#e07b00'],
          ].map(([lhs, rhs, col], i) => (
            <g key={i}>
              <text x={315} y={58+i*18} fontSize="11" fill={col} fontWeight="700" fontFamily="'Courier New',monospace">{lhs}</text>
              <text x={375} y={58+i*18} fontSize="11" fill="#1F3864" fontFamily="'Courier New',monospace">{rhs}</text>
            </g>
          ))}
        </svg>
      </div>
      <div style={S.dCaption}>
        Adding logarithms on a number line corresponds to multiplying their arguments. This is why log scales turn multiplication into addition — the foundation of slide rules and decibel calculations.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 5 — ME Applications Panel
// ─────────────────────────────────────────────────────────────────
function DiagramMEApplications() {
  const cardW = 155, cardH = 150;
  const pad = { l: 32, r: 10, t: 18, b: 32 };
  const iW = cardW - pad.l - pad.r, iH = cardH - pad.t - pad.b;
  const tMax = 4;

  const toX = t => pad.l + (t / tMax) * iW;
  const toY = (y, yMin, yMax) => pad.t + iH - ((y - yMin) / (yMax - yMin)) * iH;

  const cases = [
    {
      title: "Newton's Law of Cooling",
      subtitle: 'T(t) = T∞ + (T₀-T∞)e^(-kt)',
      color: '#c0392b',
      fn: t => 20 + 80 * Math.exp(-0.8 * t),
      yMin: 0, yMax: 100,
      yLabel: 'Temp',
      annotations: [
        { t: 0, label: 'T₀' },
        { t: tMax, label: 'T∞' },
      ],
    },
    {
      title: 'RC Circuit Discharge',
      subtitle: 'V(t) = V₀ · e^(-t/RC)',
      color: '#2E75B6',
      fn: t => Math.exp(-t / 1.2),
      yMin: 0, yMax: 1,
      yLabel: 'V/V₀',
      annotations: [
        { t: 1.2, label: 'τ=RC' },
      ],
    },
    {
      title: 'Structural Damping',
      subtitle: 'x(t) = A·e^(-ζωt)cos(ωt)',
      color: '#27ae60',
      fn: t => Math.exp(-0.4 * t) * Math.cos(2.5 * t),
      yMin: -1, yMax: 1,
      yLabel: 'x(t)',
      annotations: [],
    },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Exponential Functions in Mechanical Engineering</div>
      <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', justifyContent: 'center' }}>
        {cases.map(({ title, subtitle, color, fn, yMin, yMax, yLabel, annotations }, ci) => {
          const pts = [];
          for (let t = 0; t <= tMax; t += 0.05) {
            const y = Math.max(yMin, Math.min(yMax, fn(t)));
            pts.push(`${toX(t)},${toY(y, yMin, yMax)}`);
          }
          const zeroY = toY(0, yMin, yMax);

          return (
            <div key={ci} style={{ ...S.colCard, minWidth: '155px', flex: '1' }}>
              <div style={{ ...S.colCardTitle, color, fontSize: '0.8rem' }}>{title}</div>
              <div style={{ fontSize: '0.72rem', color: '#666', marginBottom: '4px', fontFamily: "'Courier New',monospace" }}>{subtitle}</div>
              <svg width={cardW} height={cardH} viewBox={`0 0 ${cardW} ${cardH}`} style={{ maxWidth: '100%' }}>
                {/* Zero line */}
                <line x1={pad.l} y1={zeroY} x2={pad.l+iW} y2={zeroY} stroke="#eee" strokeWidth="1"/>
                {/* Axes */}
                <line x1={pad.l} y1={pad.t} x2={pad.l} y2={pad.t+iH} stroke="#aaa" strokeWidth="1.2"/>
                <line x1={pad.l} y1={pad.t+iH} x2={pad.l+iW} y2={pad.t+iH} stroke="#aaa" strokeWidth="1.2"/>
                <text x={pad.l-3} y={pad.t+4} textAnchor="end" fontSize="8" fill="#aaa">{yLabel}</text>
                <text x={pad.l+iW+2} y={pad.t+iH+3} fontSize="8" fill="#aaa">t</text>
                {/* Curve */}
                <path d={'M ' + pts.join(' L ')} fill="none" stroke={color} strokeWidth="2.2" strokeLinejoin="round"/>
                {/* Start dot */}
                <circle cx={toX(0)} cy={toY(fn(0), yMin, yMax)} r={3} fill={color} stroke="#fff" strokeWidth="1"/>
                {/* Annotations */}
                {annotations.map(({ t, label }, i) => {
                  const sx = toX(t), sy = toY(fn(t), yMin, yMax);
                  return (
                    <g key={i}>
                      <line x1={sx} y1={pad.t} x2={sx} y2={pad.t+iH} stroke={color} strokeWidth="1" strokeDasharray="3,3" opacity="0.5"/>
                      <text x={sx} y={pad.t+iH+13} textAnchor="middle" fontSize="8" fill={color} fontWeight="700">{label}</text>
                    </g>
                  );
                })}
              </svg>
            </div>
          );
        })}
      </div>
      <div style={S.dCaption}>
        Left: A hot part cooling toward ambient temperature. Center: A capacitor discharging through a resistor — τ = RC is the time constant. Right: A damped vibration envelope governed by e^(-ζωt).
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────
export default function ExponentialEquations(props) {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Exponential Equations</h1>

      <p style={S.p}>
        Exponential functions describe any process where the rate of change is proportional to the current value — growth, decay, charging, cooling, vibration damping. In mechanical engineering you will encounter them constantly in thermodynamics, dynamics, controls, and circuit analysis.
      </p>

      <InfoBox
        title="General Form:  y = a · b^x   or   y = a · e^(kx)"
        items={[
          "a = initial value (value at x = 0)",
          "b = base.  b > 1 → growth.  0 < b < 1 → decay.",
          "e ≈ 2.718 is Euler's number — the natural base for continuous processes",
          "k = rate constant.  k > 0 → growth.  k < 0 → decay.",
        ]}
      />

      {/* Growth and Decay */}
      <h2 style={S.h2}>Growth and Decay</h2>
      <DiagramGrowthDecay />

      <Table2 rows={[
        ["General exponential",   "y = a · b^x    (b > 0, b ≠ 1)"],
        ["Natural exponential",   "y = a · e^(kx)    e ≈ 2.71828"],
        ["Growth  (k > 0)",       "y = a · e^(kt) — doubles every T_double = ln(2)/k"],
        ["Decay   (k < 0)",       "y = a · e^(-kt) — halves every T_half = ln(2)/k"],
        ["At t = 0",              "y = a · e^0 = a   (always starts at the initial value)"],
        ["Horizontal asymptote",  "Decay curves approach 0 but never reach it\nGrowth curves have no upper bound"],
        ["Euler's number e",      "e = lim(1 + 1/n)^n as n -> inf\ne is the base for all natural exponential growth/decay"],
      ]} />

      {/* Natural Log as Inverse */}
      <h2 style={S.h2}>Natural Logarithm — Inverse of e^x</h2>
      <DiagramLogInverse />

      <Table2 rows={[
        ["Definition",            "ln(x) is the inverse of e^x\ne^(ln x) = x    and    ln(e^x) = x    always"],
        ["ln(e)",                 "ln(e) = 1    (e^1 = e)"],
        ["ln(1)",                 "ln(1) = 0    (e^0 = 1)"],
        ["ln(0)",                 "Undefined — ln approaches -inf as x approaches 0 from the right"],
        ["Domain",                "ln(x) only defined for x > 0"],
        ["Solving for exponents", "If e^x = 5,  then x = ln(5) ≈ 1.609\nIf 10^x = 5,  then x = log10(5) ≈ 0.699"],
        ["Change of base",        "log_b(x) = ln(x) / ln(b)"],
      ]} />

      {/* Half-Life */}
      <h2 style={S.h2}>Half-Life and Doubling Time</h2>
      <DiagramHalfLife />

      <Table2 rows={[
        ["Decay equation",        "N(t) = N₀ · e^(-kt)    where k > 0 is the decay constant"],
        ["Half-life formula",     "T_half = ln(2) / k ≈ 0.693 / k\nTime for quantity to reduce to half its value"],
        ["Decay constant from T½","k = ln(2) / T_half"],
        ["Growth equation",       "N(t) = N₀ · e^(kt)    where k > 0"],
        ["Doubling time",         "T_double = ln(2) / k — same formula, same math"],
        ["After n half-lives",    "N = N₀ · (1/2)^n = N₀ · e^(-kn·T_half)"],
        ["ME applications",       "RC circuit discharge, radioactive material, polymer degradation,\ncreep rate, corrosion, thermal decay, acoustic damping"],
      ]} />

      {/* Log Rules */}
      <h2 style={S.h2}>Logarithm Rules</h2>
      <DiagramLogRules />

      <Table2 rows={[
        ["Product rule",          "ln(a · b) = ln(a) + ln(b)\nlog(ab) = log(a) + log(b)"],
        ["Quotient rule",         "ln(a / b) = ln(a) - ln(b)"],
        ["Power rule",            "ln(a^n) = n · ln(a)\nUsed constantly when solving for exponents"],
        ["Inverse identities",    "e^(ln x) = x    and    ln(e^x) = x"],
        ["Log of 1",              "ln(1) = 0    log(1) = 0    (any base)"],
        ["Common log vs natural", "log₁₀(x) = log(x) — base 10, used in dB and pH\nln(x) — base e, used in calculus and engineering"],
        ["Solving exponentials",  "a · e^(kx) = b\n→ e^(kx) = b/a\n→ kx = ln(b/a)\n→ x = ln(b/a) / k"],
      ]} />

      {/* ME Applications */}
      <h2 style={S.h2}>Mechanical Engineering Applications</h2>
      <DiagramMEApplications />

      <InfoBox
        title="Where Exponential Equations Appear in Mechanical Engineering"
        items={[
          "Thermodynamics — Newton's Law of Cooling:  T(t) = T∞ + (T₀ - T∞)·e^(-kt).  Heat transfer rate decays exponentially toward ambient.",
          "Circuits and Controls — RC discharge:  V(t) = V₀·e^(-t/RC).  Time constant τ = RC tells you how fast a capacitor drains.",
          "Vibrations — Damped oscillation envelope:  x(t) = A·e^(-ζωₙt)·cos(ωₐt).  The e^(-ζωₙt) term is the decaying amplitude.",
          "Materials — Creep and fatigue:  strain rate and crack growth often follow Arrhenius equation  rate = A·e^(-Ea/RT).",
          "Acoustics — Sound pressure level (dB):  L = 20·log₁₀(p/p₀).  Every 20dB is a factor of 10 in pressure.",
          "Controls — System time constant:  first-order systems reach 63% of final value at t = τ, and 99% at t = 5τ.",
        ]}
      />
    </div>
  );
}